import Moment from 'moment';
import { store } from 'store';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';

Moment.locale('es');
Moment.defaultFormat = DATE_FRONTEND_FORMAT;

export const DECIMAL_PATTERN = /^(\d)*(\.\d{1,})?$/;
export const NEGATIVE_DECIMAL_PATTERN = /^-(\d)*(\.\d{1,})?$/;
export const INTEGER_PATTERN = /^\d+$/;
export const INTEGER_PATTERN_REPLACE = /[^\d]+/g;
export const NEGATIVE_INTEGER_PATTERN_REPLACE = /-[^\d]+/g;

export const noSpaces = (val) => val?.replace(/\s/g, '');
export const noSymbolsCapitalized = (val) => val?.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
export const toUpper = (val) => val?.toString()?.toUpperCase();
export const toInteger = (val, allowNegative = false, allowZero = false) => {
  const rawOutput = val?.replace(allowNegative ? NEGATIVE_INTEGER_PATTERN_REPLACE : INTEGER_PATTERN_REPLACE, '');
  if (!rawOutput || Number.isNaN(rawOutput) || (rawOutput === '0' && !allowZero)) return null;
  return parseInt(rawOutput, 10);
};
export const toSlug = (val) => val.replace(/ /g, '-').replace(/[^\w-]+/g, '') || null;
export const normalizeText = (text = '') => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

/**
 * Format to Upper
 * @param {string|Date} date
 * @param {string|string[]} formats
 * @returns {Moment}
 */
export const toMoment = (date, formats) => {
  if (date) {
    const moment = new Moment(date, formats);
    if (moment.isValid()) {
      return moment;
    }
  }
  return null;
};

/**
 * Convierte un número serial de fecha de Excel (sistema 1900) a Moment
 * @param {number} serial
 * @returns {Moment|null}
 */
export const excelSerialToMoment = (serial) => {
  if (typeof serial !== 'number' || !Number.isFinite(serial) || serial <= 0) return null;
  // base 30/12/1899 compensa el 29/02/1900 inexistente que Excel sí cuenta
  return new Moment('1899-12-30', 'YYYY-MM-DD').add(Math.floor(serial), 'days');
};

/**
 * @param {string} val
 * @returns number|null
 */
export const decimalNormalizer = (val, allowNegative = false, _regExp) => {
  if (allowNegative && val === '-') return val;

  const regExp = _regExp || (allowNegative ? NEGATIVE_DECIMAL_PATTERN : DECIMAL_PATTERN);
  if (regExp.test(val)) return parseFloat(val);

  const value = val.toString();
  const finishWithDot = value.at(-1) === '.';
  const valWithoutDot = finishWithDot ? value.substring(0, value.length - 1) : value;
  const otherDotIdx = valWithoutDot.indexOf('.');
  const hasTwoNonConsecutiveDots = otherDotIdx !== -1
    && (finishWithDot && otherDotIdx !== valWithoutDot.length - 1);
  if ((!finishWithDot || hasTwoNonConsecutiveDots) && parseFloat(valWithoutDot)) {
    return parseFloat(valWithoutDot);
  }
  const preDotValue = toInteger(valWithoutDot, allowNegative).toString() || '';
  if (finishWithDot) return `${preDotValue}.`;
  return parseFloat(preDotValue);
};

export const capitalize = (sentence, fromConfig = true) => {
  const { solo_mayusculas = false } = store.getState()?.auth?.entidad || {};
  if ((fromConfig || solo_mayusculas) && typeof sentence === 'string') return sentence.toUpperCase();
  return sentence;
};

export const titleize = (sentense = '') => sentense.substring(0, 1).toUpperCase().concat(sentense.substring(1));

export const getDistinctValues = (values = []) => [...new Set(values)];

/**
 * List Formatter
 * @param {string[]} list
 * @param {'conjunction'|'disjunction'} type
 * @returns
 */
export const listToString = (
  list,
  type = 'conjunction',
) => new Intl.ListFormat('es-MX', { type }).format(list.map((e) => e.toString()));

export const toFixed = (n, fixed) => parseFloat(parseFloat(n).toFixed(fixed));

export const toPrecision = (_n = '', precision) => {
  const n = _n?.toString() || '';
  const dotIndex = n.toString().indexOf('.');
  if (dotIndex === -1) return n;
  const sub = n.toString().substring(0, dotIndex + precision + 1);
  return n.includes(',') ? sub : parseFloat(sub);
};
